import React from "react";
import DashboardLayout from "../../../components/layout/DashboardLayout";

const BusinessUnits = () => {

  return <DashboardLayout>BusinessUnits</DashboardLayout>;
};

export default BusinessUnits;
